export const BLOCK_SCHEMAS = {
  hero: {
    label: "Titelbild (Hero)", builtin: true,
    fields: [
      { key: "badge", label: "Kleiner Hinweis oben", kind: "text", def: "Ihr Renault & Dacia Partner" },
      { key: "title", label: "Überschrift", kind: "text", def: "Auto Thurm" },
      { key: "subtitle", label: "Text", kind: "textarea", def: "Kompetente Beratung, erstklassiger Service und eine große Auswahl an Fahrzeugen. Willkommen bei Ihrem Renault und Dacia Spezialisten." },
      { key: "image_url", label: "Hintergrundbild", kind: "image", def: "" },
      { key: "btn1_label", label: "Knopf 1 (Fahrzeuge)", kind: "text", def: "Fahrzeuge entdecken" },
      { key: "btn2_label", label: "Knopf 2 (Termin)", kind: "text", def: "Termin buchen" },
    ],
  },
  aktionen: { label: "Aktionen-Banner", builtin: true, info: "Inhalt kommt aus dem Bereich „Aktionen“ im Admin-Bereich.", fields: [] },
  stats: {
    label: "Zahlen-Leiste", builtin: true,
    fields: [{ key: "stats", label: "Zahlen (eine Zeile je Eintrag: Wert | Beschriftung)", kind: "textarea",
      def: "25+ | Jahre Erfahrung\n5000+ | Zufriedene Kunden\n100% | Renault-Qualität\n24h | Notfall-Service" }],
  },
  services: {
    label: "Leistungen", builtin: true,
    fields: [
      { key: "title", label: "Überschrift", kind: "text", def: "Unsere Leistungen" },
      { key: "subtitle", label: "Text", kind: "textarea", def: "Von der professionellen Wartung bis zum Fahrzeugkauf – wir bieten Ihnen alles aus einer Hand." },
    ],
  },
  vehicles: {
    label: "Aktuelle Fahrzeuge", builtin: true,
    fields: [
      { key: "title", label: "Überschrift", kind: "text", def: "Aktuelle Fahrzeuge" },
      { key: "subtitle", label: "Text", kind: "text", def: "Entdecken Sie unsere neuesten Angebote." },
    ],
  },
  why_us: {
    label: "Warum Auto Thurm", builtin: true,
    fields: [
      { key: "title", label: "Überschrift", kind: "text", def: "Warum Auto Thurm?" },
      { key: "image_url", label: "Bild", kind: "image", def: "" },
    ],
  },
  testimonials: {
    label: "Kundenstimmen", builtin: true,
    fields: [{ key: "title", label: "Überschrift", kind: "text", def: "Das sagen unsere Kunden" }],
  },
  cta: {
    label: "Termin-Aufruf", builtin: true,
    fields: [
      { key: "title", label: "Überschrift", kind: "text", def: "Bereit für Ihren nächsten Besuch?" },
      { key: "text", label: "Text", kind: "textarea", def: "Vereinbaren Sie jetzt einen Termin oder rufen Sie uns direkt an. Wir freuen uns auf Sie!" },
    ],
  },
  callback: {
    label: "Rückruf-Formular", builtin: true, info: "Erscheint nur, wenn „Kontakt“ ausgeschaltet ist.",
    fields: [
      { key: "title", label: "Überschrift", kind: "text", def: "Rückruf anfordern" },
      { key: "text", label: "Text", kind: "textarea", def: "Hinterlassen Sie Ihren Namen und Ihre Telefonnummer oder E-Mail - wir melden uns." },
    ],
  },
  text: {
    label: "Textbereich",
    fields: [
      { key: "title", label: "Überschrift", kind: "text", def: "Neue Überschrift" },
      { key: "text", label: "Text", kind: "textarea", def: "Hier steht Ihr Text." },
      { key: "align", label: "Ausrichtung", kind: "select", options: [["left", "Links"], ["center", "Mittig"]], def: "left" },
      { key: "background", label: "Hintergrund", kind: "select", options: [["white", "Weiß"], ["grey", "Grau"], ["black", "Schwarz"], ["yellow", "Gelb"]], def: "white" },
    ],
  },
  image_text: {
    label: "Bild mit Text",
    fields: [
      { key: "title", label: "Überschrift", kind: "text", def: "Neue Überschrift" },
      { key: "text", label: "Text", kind: "textarea", def: "Beschreiben Sie hier Ihr Angebot." },
      { key: "image_url", label: "Bild", kind: "image", def: "" },
      { key: "image_side", label: "Bild-Seite", kind: "select", options: [["left", "Links"], ["right", "Rechts"]], def: "right" },
      { key: "button_label", label: "Knopf-Text (optional)", kind: "text", def: "" },
      { key: "button_link", label: "Knopf-Ziel (z.B. /termin oder https://...)", kind: "text", def: "" },
    ],
  },
  banner: {
    label: "Hinweis-Banner",
    fields: [
      { key: "text", label: "Text", kind: "text", def: "Neu: Jetzt Reifenwechsel-Termine sichern!" },
      { key: "button_label", label: "Knopf-Text (optional)", kind: "text", def: "Termin buchen" },
      { key: "button_link", label: "Knopf-Ziel", kind: "text", def: "/termin" },
    ],
  },
};

const BUILTIN_ORDER = ["hero", "aktionen", "stats", "services", "vehicles", "why_us", "testimonials", "cta", "callback"];

export const DEFAULT_LAYOUT = BUILTIN_ORDER.map((type) => ({ id: type, type, visible: true, props: {} }));

export const newBlock = (type) => ({
  id: `${type}-${Date.now().toString(36)}`,
  type,
  visible: true,
  props: Object.fromEntries((BLOCK_SCHEMAS[type]?.builtin ? [] : BLOCK_SCHEMAS[type].fields).map((f) => [f.key, f.def])),
});

export const parseStats = (raw) => {
  if (!raw) return null;
  const items = raw.split("\n").map((l) => l.split("|").map((x) => x.trim())).filter((x) => x[0]);
  return items.length ? items.map(([value, label = ""]) => ({ value, label })) : null;
};

export const safeLink = (link) => {
  const l = (link || "").trim();
  if (l.startsWith("/") && !l.startsWith("//")) return { internal: true, href: l };
  if (l.startsWith("https://")) return { internal: false, href: l };
  return null;
};

export const safeImage = (url, backendUrl) => {
  const u = (url || "").trim();
  if (u.startsWith("https://")) return u;
  if (u.startsWith("/api/")) return `${backendUrl}${u}`;
  return "";
};
